import UserSearch from "../components/users/UserSearch"
import UserResults from "../components/users/UserResults"
function home() {
    return (
        <>
            
            <UserSearch/>
            <UserResults/>            
        </>
    )
}

export default home
